import PayrollSection from './PayrollSection';

export default PayrollSection;
